import React from "react";
import TablePagination from "@mui/material/TablePagination";
import TablePaginationActions from "./PaginationActions";

export const Pagination = ({ totalCount, rowsPerPage, page, onPageChange }) => {
  // Calculate the number of pages
  const pageCount = Math.ceil(totalCount / rowsPerPage);

  // Ensure page is within valid range
  const validPage = Math.max(0, Math.min(page, pageCount - 1));

  return (
    <TablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={totalCount}
      rowsPerPage={rowsPerPage}
      page={validPage}
      onPageChange={onPageChange}
      ActionsComponent={TablePaginationActions}
    />
  );
};
